module.exports = __webpack_public_path__ + "static/media/belcolor__9.fb0fb2d7.jpg";